// The two ways a Card product can be shaped in 3D:
//   Folded    — hinged double panel with a fold pivot (default when
//               the product has no cutting path).
//   CutShape  — silhouette extruded from the product's SVG cutting
//               path (single flat piece, no fold).
//
// Mutually exclusive at the product level. Glass products have no
// card form — deriveCardForm returns null in that case.

enum EProductCardForm {
    CutShape = 'cut_shape',
    Folded = 'folded',
}

export { EProductCardForm };
